import React from 'react';
import { AboutSection, ValuePillarsSection } from '../components/sections';

export const AboutPage: React.FC = () => {
  return (
    <div className="pt-20">
      <AboutSection />
      <ValuePillarsSection />
    </div>
  );
};
